import { sendGTMEvent } from '@next/third-parties/google'

export type GA4PurchaseEventParams = {
  transactionId: string
  value: number
  currency: string
  items: Array<{
    itemId: string
    itemName: string
    itemCategory?: string
    price: number
    quantity: number
  }>
  userId?: string | number
  userName?: string
  userPhone?: string
  userEmail?: string
}

// 값이 있는 필드만 포함하는 user 객체 생성
const buildUserObject = (params: GA4PurchaseEventParams) => {
  const user: Record<string, string | number> = {}
  if (params.userId !== null && params.userId !== undefined) {
    user.id = params.userId
  }
  if (params.userName) {
    user.name = params.userName
  }
  if (params.userPhone) {
    user.ph_num = params.userPhone
  }
  if (params.userEmail) {
    user.email = params.userEmail
  }
  return Object.keys(user).length > 0 ? user : undefined
}

// 값이 있는 필드만 포함하는 item 객체 생성
const buildItemObject = (item: GA4PurchaseEventParams['items'][number]) => ({
  item_id: item.itemId,
  item_name: item.itemName,
  ...(item.itemCategory && { item_category: item.itemCategory }),
  price: item.price,
  quantity: item.quantity,
})

export const sendGA4PurchaseEvent = (params: GA4PurchaseEventParams) => {
  const user = buildUserObject(params)

  sendGTMEvent({
    event: 'purchase',
    ecommerce: {
      transaction_id: params.transactionId,
      value: params.value,
      currency: params.currency,
      items: params.items.map(buildItemObject),
    },
    ...(user && { user }),
  })
}

export const sendGA4JpPurchaseEvent = (params: GA4PurchaseEventParams) => {
  const user = buildUserObject(params)

  sendGTMEvent({
    event: 'jp_purchase',
    ecommerce: {
      transaction_id: params.transactionId,
      value: params.value,
      currency: params.currency,
      items: params.items.map(buildItemObject),
    },
    ...(user && { user }),
  })
}

export const sendGA4PurchaseDoneEvent = (params: GA4PurchaseEventParams) => {
  const user = buildUserObject(params)

  sendGTMEvent({
    event: 'purchase_done',
    ecommerce: {
      transaction_id: params.transactionId,
      value: params.value,
      currency: params.currency,
      items: params.items.map(buildItemObject),
    },
    ...(user && { user }),
  })
}

export const sendGA4PageViewEvent = (params?: { pageTitle?: string; pageLocation?: string; pagePath?: string }) => {
  sendGTMEvent({
    event: 'page_view',
    ...(params?.pageTitle && { page_title: params.pageTitle }),
    page_location: params?.pageLocation || window.location.href,
    page_path: params?.pagePath || window.location.pathname,
  })
}

// 커스텀 이벤트 (GA4에서 커스텀 디멘션 설정 필요)
export const sendGA4CustomEvent = (eventName: string, parameters: object) => {
  sendGTMEvent({
    event: eventName,
    ...parameters,
  })
}

export const sendGA4PurchaseStartEvent = (params: GA4PurchaseEventParams) => {
  const user = buildUserObject(params)

  sendGTMEvent({
    event: 'purchase_start',
    ecommerce: {
      transaction_id: params.transactionId,
      value: params.value,
      currency: params.currency,
      items: params.items.map(buildItemObject),
    },
    ...(user && { user }),
  })
}
